import BigNumber from 'bignumber.js';

/**
 * Calculates the trading fee for an option trade
 * https://docs.paradex.trade/documentation/perpetual-options/trading-fees
 * @param size - The size of the option trade
 * @param feeRate - The fee rate to apply
 * @param spotPrice - The price of the underlying asset
 * @param optionTradePrice - The price of the option
 * @returns The calculated fee
 */
export function calculateOptionTradeFee(
  size: BigNumber,
  feeRate: BigNumber,
  spotPrice: BigNumber,
  optionTradePrice: BigNumber,
): BigNumber {
  const underlyingSpotNotional = size.multipliedBy(spotPrice);
  const feeBasedOnSpotPrice = underlyingSpotNotional.multipliedBy(feeRate);

  const optionTradeValue = size.multipliedBy(optionTradePrice);
  let fee = feeBasedOnSpotPrice;

  if (fee.isGreaterThan(0)) {
    const feeCap = optionTradeValue.multipliedBy(
      new BigNumber(5).div(100),
    );
    fee = BigNumber.min(fee, feeCap);
  } else {
    const feeFloor = optionTradeValue.multipliedBy(
      new BigNumber(-5).div(100),
    );
    fee = BigNumber.max(fee, feeFloor);
  }

  return fee;
}
